import { connect } from 'react-redux';
import {
  isSuperhugggEmailClaim,
  isSuperhugggSMSClaim,
} from 'redux/modules/huggg';
import {
  getView,
  isStashed,
  stash,
  setRecipientEmail,
  setRecipientNumber,
  getEmail,
  getNumber,
  isStashing,
  getError,
  changeRecipientEmail,
  changeRecipientNumber,
} from 'redux/modules/stash';
import Stash from './Stash';

const mapStateToProps = (state) => ({
  isStashed: isStashed(state),
  isSuperhugggEmailClaim: isSuperhugggEmailClaim(state),
  isSuperhugggSMSClaim: isSuperhugggSMSClaim(state),
  view: getView(state),
  email: getEmail(state),
  number: getNumber(state),
  stashing: isStashing(state),
  error: getError(state),
});

export default connect(mapStateToProps, {
  stashAction: stash,
  setRecipientEmail,
  setRecipientNumber,
  changeRecipientEmail,
  changeRecipientNumber,
})(Stash);
